import React, {useEffect, useState} from "react";
import libToast from "../../lib/LibToast";
import Api from "../../servicios/api/Api";
import EseTable from "./EseTable";


const apiCliente = Api.getApiCliente();

const EseIndex = () => {
  const [eseList, setEseList] = useState([])
  
  useEffect(() => {
    
    (async () => {
      
      const response = await apiCliente.allEse();
      if (!response.success) {
        libToast.alert("Error " + response.message);
      }
      
      setEseList(response.data["ese-all"]);
    })()
  }, []);
  
  return (
    <div>
      <EseTable list={eseList}/>
    </div>
  );
};

export default EseIndex;